import { render, staticRenderFns } from "./MiniCourses.vue?vue&type=template&id=0ae550c3&scoped=true&"
import script from "./MiniCourses.vue?vue&type=script&lang=ts&"
export * from "./MiniCourses.vue?vue&type=script&lang=ts&"
import style0 from "./MiniCourses.vue?vue&type=style&index=0&id=0ae550c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae550c3",
  null
  
)

export default component.exports